var EventObject = /** @class */ (function () {
    function EventObject() {
        this.events = {};
    }
    EventObject.prototype.$notifyEvent = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.events[eventName]) {
            for (var i = 0; i < this.events[eventName].length; i++) {
                this.events[eventName][i].apply(this, args);
            }
        }
    };
    EventObject.prototype.on = function (eventName, cb) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(cb);
    };
    return EventObject;
}());
export { EventObject };
